export default __webpack_public_path__ + "static/media/star.c07a5d2e.svg";